<template>
  <card class="document-card margin-bottom-s" :custom-menu="isUploadedDocument" :has-content-padding="false">
    <div class="card-content flex-row align-center">
      <div class="document-left flex-row align-center"
           :class="{ 'required': document.state === 'REQUIRED' || document.state === 'UPLOADED',
           'failed': document.state === 'FAILED_VERIFICATION' }">
        <icon
          icon-name="description"
          :size="'20px'"
          :color="Colors.riseupBlack"
          class="document-icon"
        />
        <div class="document-info flex-column margin-right-s">
          <div class="ri-bold-body black-text">{{ documentTitle }}</div>
          <div v-if="document.updatedAt" class="ri-small-body gray-text">
            העלית את המסמך ב-{{formatDate(document.updatedAt)}}
          </div>
        </div>
        <icon v-if="document.state !== 'REQUIRED'"
            :icon-name="statusIcon"
            :size="'20px'"
            :color="statusColor"
        />
      </div>

      <div  v-if="document.state === 'REQUIRED'" class="document-actions flex-row align-center margin-right-auto">
        <template>
          <icon
              icon-name="add"
              :size="'20px'"
              :color="Colors.riseupBlack"
              class="document-add-icon"
              @click="$emit('upload', document)"
          />
        </template>
      </div>
      <template v-if="isUploadedDocument">
        <bottom-sheet-overflow-button
            :bottom-sheet-component="menuComponent"
            :component-props="menuComponentProps"
        />
      </template>
    </div>
  </card>
</template>

<script>
import moment from 'moment';
import BaseUI from '@riseupil/base-ui';
import BottomSheetOverflowButton from '@/base-components/BottomSheetOverflowButton';
import DocumentMenu from './DocumentMenu.vue';

const DOCUMENT_TYPE_LABELS = {
  PAYCHECK: 'תלוש משכורת',
  TAX_RETURN: 'דוח מס',
  BANK_STATEMENT: 'אישור מס',
  PROPERTY_APPRAISAL: 'שומה של הנכס',
  PURCHASE_AGREEMENT: 'הסכם רכישה',
  ID_CARD: 'תעודת זהות',
  OTHER: 'אחר',
};

export default {
  name: 'DocumentCard',
  components: {
    Card: BaseUI.Card,
    Icon: BaseUI.Icon,
    BottomSheetOverflowButton,
  },
  props: {
    document: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      Colors: BaseUI.Colors,
      menuComponent: DocumentMenu,
    };
  },
  computed: {
    documentTitle() {
      return DOCUMENT_TYPE_LABELS[this.document.documentType] || this.document.documentType;
    },
    isUploadedDocument() {
      return this.document.state !== 'REQUIRED';
    },
    statusIcon() {
      if (this.document.state === 'VERIFIED') { return 'check_circle'; }
      if (this.document.state === 'UPLOADED') { return 'schedule'; }
      return 'cancel';
    },
    statusColor() {
      if (this.document.state === 'VERIFIED') { return BaseUI.Colors.riseupGreen; }
      if (this.document.state === 'UPLOADED') { return BaseUI.Colors.riseupOrange; }
      return BaseUI.Colors.riseupRed;
    },
    verificationIcon() {
      return this.document.state === 'VERIFIED' ? 'check_circle' : 'cancel';
    },
    verificationColor() {
      return this.document.state === 'VERIFIED' ? BaseUI.Colors.riseupGreen : BaseUI.Colors.riseupRed;
    },
    verificationText() {
      if (this.document.state === 'VERIFIED') { return 'מאומת'; }
      if (this.document.state === 'UPLOADED') { return 'בבדיקה'; }
      return 'נכשל באימות';
    },
    menuComponentProps() {
      return {
        menuItems: [
          {
            text: 'להחליף קובץ',
            iconProps: {
              iconName: 'upload',
              fill: true,
            },
            onClick: this.handleChangeFile,
          },
          {
            text: 'להוריד',
            iconProps: {
              iconName: 'download',
              fill: true,
            },
            onClick: this.handleDownload,
          },
        ],
      };
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    handleChangeFile() {
      this.$emit('upload', this.document);
    },
    handleDownload() {
      this.$emit('download', this.document);
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@riseupil/base-ui/src/scss/riseup-colors";
@import "~@riseupil/base-ui/src/scss/spacings";

.document-card {
  background-color: $riseup_white;
  border-radius: 12px;
  padding: 8px 12px;

  .document-icon {
    border-radius: 50%;
    height: 34px;
    width: 34px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: $riseup_light_green;
  }

  .required .document-icon {
    background: $riseup_gray_-1;
  }

  .failed .document-icon {
    background: $riseup_danger_red;
  }

  .document-add-icon {
    border-radius: 8px;
    margin-left: 8px;
    height: 34px;
    width: 34px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: $riseup_gray_-1;

    &:hover {
      cursor: pointer;
    }
  }

  .card-content {
    width: 100%;
  }

  .document-left {
    text-align: right;
    flex: 1;
  }

  .document-info {
    flex: 1;
    text-align: right;
  }

  .gray-text {
    color: $riseup_gray_2;
  }
}
</style>
